module.exports = __webpack_public_path__ + "static/media/14_r_ctoyka_87.86_53.15.2f2f0610.png";